import React from "react";

import { CssBaseline } from "@mui/material";
import { createTheme, StyledEngineProvider, ThemeProvider } from "@mui/material/styles";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterLuxon } from "@mui/x-date-pickers/AdapterLuxon";
import { LicenseInfo } from "@mui/x-license";
import { ConfirmProvider } from "material-ui-confirm";

const MuiLayout = ({
  children
}) => {
  const MUI_KEY =
    "60d0b1b07969248a372f8c593670fcd4Tz0xMjQ2MDgsRT0xODAyMzkwMzk5MDAwLFM9cHJlbWl1bSxMTT1zdWJzY3JpcHRpb24sUFY9aW5pdGlhbCxLVj0y";
  LicenseInfo.setLicenseKey(MUI_KEY);
  const muiTheme = createTheme({
    palette: {
      green: {
        light: "#00BB77",
        main: "#00BB77",
        dark: "#008051",
        contrastText: "#FFFFFF",
      },
      darkGreen:{
        light: "#00BB77",
        main: "#00452C",
        dark: "#002b1b",
        contrastText: "#FFFFFF",
      },
      burgandy: {
        light: "#ad454c",
        main: "#603033",
        dark: "#472426",
        contrastText: "#FFFFFF",
      },
      pink: {
        light: "#E60073",
        main:"#E60073",
        dark: "#800040",
        contrastText: "#FFFFFF",
      },
      clientblue: {
        light: "#3070E7",
        main: "#3070E7",
        dark: "#0F0E47",
        contrastText: "#FFFFFF",
      },
      cancel: {
        light: "#E0E0E0",
        main: "#E0E0E0",
        dark: "#E0E0E0",
        contrastText: "#000000",
      }
    }
  });

  return (
    <React.StrictMode>
        <LocalizationProvider dateAdapter={AdapterLuxon} adapterLocale="en-us">
          <StyledEngineProvider injectFirst>
            <ThemeProvider theme={muiTheme}>
              <CssBaseline />
              <ConfirmProvider>
                {children}
              </ConfirmProvider>
            </ThemeProvider>
          </StyledEngineProvider>
        </LocalizationProvider>
    </React.StrictMode>
  );
};

export default MuiLayout;
